import { Api } from '@/api/api';
import { TargetTrackerRequest } from '@/api/requests/target-tracker/target-tracker-request';
import { UpdateTargetTrackerPaymentOwnerRequest } from '@/api/requests/target-tracker/update-target-tracker-payment-owner-request';
import { UpdateTargetTrackerPaymentRequest } from '@/api/requests/target-tracker/update-target-tracker-payment-request';
import { TargetTrackerAdvisor } from '@/shared/target-tracker-advisor';
import { TargetTrackerOverview } from '@/shared/target-tracker-overview';

export class TargetTrackerApi extends Api {
    public getTargetTrackerOverviewAsync(filters: TargetTrackerRequest): Promise<Array<TargetTrackerOverview>> {
        return this.getAsync<Array<TargetTrackerOverview>>(`v1/target-tracker`, filters);
    }

    public getTargetTrackerDetailsAsync(legalAdvisorId: string, filters: TargetTrackerRequest): Promise<TargetTrackerAdvisor> {
        return this.getAsync<TargetTrackerAdvisor>(`v1/target-tracker/${legalAdvisorId}`, filters);
    }

    public async updateTargetTrackerPaymentAsync(paymentId: string, request: UpdateTargetTrackerPaymentRequest): Promise<string> {
        const url = `v1/target-tracker/payment/${paymentId}`;
        const location = await this.putAsync<string>(`v1/target-tracker/payment/${paymentId}`, { ...request });
        return location.replace(`${url}/`, ``);
    }

    public async updateTargetTrackerPaymentOwnerAsync(paymentId: string, request: UpdateTargetTrackerPaymentOwnerRequest): Promise<string> {
        const url = `v1/target-tracker/advisor/${paymentId}`;
        const location = await this.putAsync<string>(`v1/target-tracker/advisor/${paymentId}`, { ...request });
        return location.replace(`${url}/`, ``);
    }

    public constructor() {
        super();
    }
}
